// External Dependencies:
import React from 'react'
import { withRouter } from 'react-router-dom'

class Link extends React.Component {
	handleClick = ( e ) => {
		const editorIsOpen = document.documentElement.classList.contains( 'with-editor-open' )

		if ( editorIsOpen ) {
			e.preventDefault()
			return
		}

		let { history, to, onClick } = this.props
		const isExternal = /^https?:\/\//.test( to )

		if ( isExternal ) {
			return
		}

		e.preventDefault()

		if ( onClick ) {
			onClick()
		}

		if ( '/' != siteData.site_base_path && to && to.includes( siteData.site_base_path ) ) {
			to = to.replace( siteData.site_base_path, '' )
		}

		history.push( to )
	}

	render() {
		let { children, to, className, activeClassName, fuzzyMatch, location } = this.props
		const isExternal = /^https?:\/\//.test( to )
		const target = isExternal ? '_blank' : null

		if ( ! className ) {
			className = ''
		}

		if ( activeClassName && fuzzyMatch && location.pathname.indexOf( to ) > -1 ) {
			className += ` ${activeClassName}`
		} else if ( activeClassName && location.pathname == to ) {
			className += ` ${activeClassName}`
		}

		return (
			<a href={ to } className={ className } onClick={ this.handleClick } target={ target }>{ children }</a>
		)
	}
}

export default withRouter( Link )
